<script setup lang="ts">
import { Card, CardTitle, CardContent, CardFooter } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"
import { useConfigStore } from "@/stores/config"
import { useHelpStore } from "@/components/af/Help/help.store"
import { useCookies } from "@vueuse/integrations/useCookies"

const { stopAudio } = useHelpStore()
const { urls } = useConfigStore()

const afAuthSession = useCookies().get("af-session-auth")
const branding = afAuthSession?.branding

async function goNext() {
  await stopAudio()
  window.location.href = urls.personalAccount
}
</script>

<template>
  <div class="container flex justify-center">
    <Card
      class="flex items-center justify-center border-pink-200 text-center lg:w-[500px]"
    >
      <FaIcon icon="fat fa-person-to-door" class="text-pink h-10 w-10" />
      <CardTitle as="h1" class="text-grey-darken-1">
        <template v-if="branding">
          {{ $t("onboarding.transition.branding.title") }}
        </template>
        <template v-else>
          {{ $t("onboarding.transition.no_branding.title") }}
        </template>
      </CardTitle>

      <Separator class="bg-grey-lighten-3 w-[180px]!" />

      <CardContent
        class="flex flex-col items-center gap-4 py-0 text-sm md:text-base"
      >
        <p class="text-grey-darken-1 text-center font-sans" v-if="branding">
          {{ $t("onboarding.transition.branding.body_1") }}
        </p>
        <p class="text-grey-darken-1 text-center font-sans" v-else>
          {{ $t("onboarding.transition.no_branding.body_1") }}
        </p>

        <p class="text-grey-darken-1 text-center font-sans" v-if="branding">
          {{ $t("onboarding.transition.branding.body_2") }}
        </p>
        <p class="text-grey-darken-1 text-center font-sans" v-else>
          {{ $t("onboarding.transition.no_branding.body_2") }}
        </p>
      </CardContent>

      <CardFooter>
        <Button
          class="bg-pink hover:bg-pink-darken-1 w-full md:w-auto"
          @click="goNext"
        >
          {{ $t("onboarding.transition.cta") }}
        </Button>
      </CardFooter>
    </Card>
  </div>
</template>
